import {TrackingClientStateHolder} from '../helpers/clientState';

export const trackBeginCheckout =
  ({
    customerType,
    entryTimestamp,
    label,
  }: {
    customerType: 'existing' | 'new' | 'guest';
    entryTimestamp: number;
    label: 'internal_checkout' | 'klarna_express_checkout';
  }) =>
  (clientState: TrackingClientStateHolder) => {
    const {currentPage} = clientState.getCurrent();

    const event = {
      event: 'begin_checkout',
      customer_type: customerType,
      content_name: currentPage?.page?.path || '',
      page_type: currentPage?.page?.type || '',
      ecommerce: {},
      event_timestamp_ay: entryTimestamp,
      label,
    };

    return event;
  };
